// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"ddef9da3","358":"00f3afcc","544":"d282e438","851":"8e4af6c5","862":"89f5bb0f"}[chunkId] + ".chunk.js";
};